module.exports = __webpack_public_path__ + "img/h-page4-21.6d5561c1.png";